var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},_vm._l((_vm.badge_collection),function(badge,index){return _c('b-badge',{key:index,staticClass:"float-left font-sm my-1 ml-2",attrs:{"pill":""}},[_vm._v(_vm._s(badge))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }